// Generated by `npm run help:registry` from docs/help-videos/**. Do not edit by hand.
import type { HelpEntry } from './help-types';

export const HELP_ENTRIES: readonly HelpEntry[] = [
  {
    "id": "flow-first-client",
    "kind": "flow",
    "section": "flows",
    "title": "First client, start to assessment",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Take a brand new client from creation to a first posture result and a first Spectrum of Patterns assessment, and see the resulting pattern on the client.",
    "routes": [
      "/dashboard",
      "/clients",
      "/clients/:id",
      "/posture-analysis",
      "/clients/:id/posture-analysis/:analysisId",
      "/sop-assessment"
    ],
    "alsoShownIn": [],
    "steps": [
      "In **Clients**, choose **Add Client**, fill in name and height, then **Create client**.",
      "Open the client's **Client 360** page and choose **Posture**.",
      "Choose **Start Camera**, capture each view, then **Finish capture** and **Save**.",
      "Back on **Client 360**, choose **Assessment** to start the SoP assessment.",
      "Enter the left and right values for each test, then choose **Save**.",
      "See the pattern on **Client 360**, in the header and the **Assessments** tab."
    ],
    "flowText": "Client, then posture photos, then SoP, then pattern. You add the client once, and every later step starts from their Client 360 page. The posture photos give a first read of the client's orientation. The SoP assessment adds measured test values on both sides. Harry combines them into classification tags that sit on the client and follow them into drills.",
    "keyConcept": null,
    "seeAlso": [
      "clients-add-client",
      "clients-find-and-open-client",
      "posture-analysis-start-new",
      "posture-analysis-taking-photos",
      "posture-analysis-read-result",
      "sop-create-assessment",
      "sop-goniometer",
      "sop-read-results"
    ],
    "video": "help-videos/flow-first-client/20261017T234902Z.mp4",
    "captions": "help-videos/flow-first-client/20261017T234902Z-r2.vtt",
    "poster": "help-videos/flow-first-client/20261017T234902Z.jpg",
    "durationSec": 276,
    "recordedAt": "2026-10-17T23:49:02Z"
  },
  {
    "id": "flow-assessment-to-drill-plan",
    "kind": "flow",
    "section": "flows",
    "title": "From assessment to drill plan",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Turn an assessed client's pattern into a drill plan, assign it to them, and find it again later.",
    "routes": [
      "/clients/:id",
      "/drills",
      "/drill-planner",
      "/clients"
    ],
    "alsoShownIn": [],
    "steps": [
      "In **Settings**, turn on **Enable Experimental Features** for the Drill Planner.",
      "On **Client 360**, check the needs on the **Needs / Prescription** card.",
      "Choose **Open Drill Library**, then **Suggest Drills** in the **Drill Library**.",
      "In the Drill Planner, pick a template under **Choose a Template**.",
      "Name the plan, adjust the drills, then choose **Save & Assign to Client**.",
      "Find the plan again on **Client 360**, in the **Programs** tab."
    ],
    "flowText": "Pattern, then needs, then drills, then plan, then back to the client. The classification from posture and SoP becomes the client's needs. The needs filter the Drill Library. Suggest Drills hands the same needs to the Drill Planner, which fills a template for you. The saved plan is assigned to the client and lives on their Client 360 page under Programs.",
    "keyConcept": null,
    "seeAlso": [
      "clients-find-and-open-client",
      "sop-read-results",
      "drills-find-and-filter-drills",
      "drills-build-a-drill-plan",
      "drills-reuse-a-saved-drill-plan",
      "progression-model-read-the-three-phases"
    ],
    "video": "help-videos/flow-assessment-to-drill-plan/20261018T012210Z.mp4",
    "captions": "help-videos/flow-assessment-to-drill-plan/20261018T012210Z.vtt",
    "poster": "help-videos/flow-assessment-to-drill-plan/20261018T012210Z.jpg",
    "durationSec": 241,
    "recordedAt": "2026-10-18T01:22:10Z"
  },
  {
    "id": "clients-add-client",
    "kind": "subsection",
    "section": "clients",
    "title": "Add a new client",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Add a new client to the roster with the Add Client form, so the client is ready for a posture analysis or an SoP assessment.",
    "routes": [
      "/clients",
      "/clients/new"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **Clients** in the side menu.",
      "Choose **Add Client**.",
      "Fill in **First name** and the height, plus any other details you know.",
      "On a phone, tap **Next** to reach the second step of the form.",
      "Choose **Create client**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/clients-add-client/20261015T204252Z.mp4",
    "captions": "help-videos/clients-add-client/20261015T204252Z.vtt",
    "poster": "help-videos/clients-add-client/20261015T204252Z.jpg",
    "durationSec": 82,
    "recordedAt": "2026-10-15T20:42:52Z"
  },
  {
    "id": "clients-edit-or-delete-client",
    "kind": "subsection",
    "section": "clients",
    "title": "Edit or delete a client",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Update a client's details from the roster or from Client 360, or delete a client you no longer need.",
    "routes": [
      "/clients",
      "/clients/:id"
    ],
    "alsoShownIn": [],
    "steps": [
      "On **Clients**, open the actions menu at the end of the client's row.",
      "Choose **Edit Client**, or choose **Edit** in the **Client 360** header.",
      "Change the details you need, then choose **Save changes**.",
      "To delete a client, choose **Delete Client** in the actions menu, then **Delete**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/clients-edit-or-delete-client/20261015T175521Z.mp4",
    "captions": "help-videos/clients-edit-or-delete-client/20261015T175521Z.vtt",
    "poster": "help-videos/clients-edit-or-delete-client/20261015T175521Z.jpg",
    "durationSec": 86,
    "recordedAt": "2026-10-15T17:55:21Z"
  },
  {
    "id": "clients-find-and-open-client",
    "kind": "subsection",
    "section": "clients",
    "title": "Find and open a client",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Find a client on the roster with search, filters and sort, select them, and open their full record in Client 360.",
    "routes": [
      "/clients",
      "/clients/:id"
    ],
    "alsoShownIn": [],
    "steps": [
      "Open **Clients** and type in **Search by name, email, or ID…** to narrow the list.",
      "Use **Filters** or the sort list to narrow or order the roster.",
      "Click the client's row to select them.",
      "Choose **Client 360**, or click the client's name, to open the full record.",
      "Use the tabs, such as **Overview** and **Assessments**, to browse the record."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/clients-find-and-open-client/20261015T033603Z.mp4",
    "captions": "help-videos/clients-find-and-open-client/20261015T033603Z.vtt",
    "poster": "help-videos/clients-find-and-open-client/20261015T033603Z.jpg",
    "durationSec": 93,
    "recordedAt": "2026-10-15T03:36:03Z"
  },
  {
    "id": "posture-analysis-add-pelvis-landmarks",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Add pelvis landmarks",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Pin the front and back points of the pelvis (ASIS and PSIS) on a photo so Harry reads the pelvis from your pins, and how to remove them.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "On a side photo, choose **Add Pelvis Landmarks**.",
      "Tap the front of the pelvis (ASIS), then the back (PSIS), as the prompt above the toolbar asks.",
      "To clear the pins on every view, choose **Remove ASIS and PSIS markers from all views**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-add-pelvis-landmarks/20261018T000637Z.mp4",
    "captions": "help-videos/posture-analysis-add-pelvis-landmarks/20261018T000637Z.vtt",
    "poster": "help-videos/posture-analysis-add-pelvis-landmarks/20261018T000637Z.jpg",
    "durationSec": 34,
    "recordedAt": "2026-10-18T00:06:37Z"
  },
  {
    "id": "posture-analysis-adjust-landmarks",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Adjust landmarks and the pelvis line",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Drag a landmark, a pelvis pin, or the whole pelvis line to where it belongs, or go back to what Harry detected.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "Drag a landmark dot on the photo to where it belongs.",
      "Drag an ASIS or PSIS pin, or grab the middle of the pelvis line to move both pins together.",
      "Choose **Reset overlay alignment** to go back to the detected landmarks."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-adjust-landmarks/20261018T001429Z.mp4",
    "captions": "help-videos/posture-analysis-adjust-landmarks/20261018T001429Z.vtt",
    "poster": "help-videos/posture-analysis-adjust-landmarks/20261018T001429Z.jpg",
    "durationSec": 34,
    "recordedAt": "2026-10-18T00:14:29Z"
  },
  {
    "id": "posture-analysis-ai-vision-settings",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Tune the AI Vision settings",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Find the AI Vision settings in Capture Settings, change how sure Harry must be before it shows a landmark, and reset them to the defaults.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **Settings**, then open **Advanced Settings**.",
      "Under **AI Vision**, move **Visibility Threshold**; choose **Reset** to restore the defaults."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-ai-vision-settings/20261018T013343Z.mp4",
    "captions": "help-videos/posture-analysis-ai-vision-settings/20261018T013343Z.vtt",
    "poster": "help-videos/posture-analysis-ai-vision-settings/20261018T013343Z.jpg",
    "durationSec": 30,
    "recordedAt": "2026-10-18T01:33:43Z"
  },
  {
    "id": "posture-analysis-auto-capture-settings",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Set up auto-capture",
    "audience": "app",
    "gatedBy": null,
    "purpose": "See how auto-capture takes the photo by itself once the client holds still, and how to change how steady, how long, and the countdown.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "With the camera on, choose **Settings**, then **Camera Settings**.",
      "Under **Auto-Capture**, turn **Enable Auto-Capture** on or off.",
      "Adjust **Stability Threshold**, **Hold Duration** and **Countdown Duration**, or choose **Reset**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-auto-capture-settings/20261018T002843Z.mp4",
    "captions": "help-videos/posture-analysis-auto-capture-settings/20261018T002843Z.vtt",
    "poster": "help-videos/posture-analysis-auto-capture-settings/20261018T002843Z.jpg",
    "durationSec": 55,
    "recordedAt": "2026-10-18T00:28:43Z"
  },
  {
    "id": "posture-analysis-compare",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Compare two posture analyses",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Compare two saved posture analyses of a client side by side, or with a slider, to see what changed.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Experimental Features on, open a saved assessment from **Select assessment**, then choose **Compare**.",
      "Under **History**, choose an earlier analysis.",
      "Switch between **Side by side** and **Slider**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-compare/20261018T014631Z.mp4",
    "captions": "help-videos/posture-analysis-compare/20261018T014631Z.vtt",
    "poster": "help-videos/posture-analysis-compare/20261018T014631Z.jpg",
    "durationSec": 39,
    "recordedAt": "2026-10-18T01:46:31Z"
  },
  {
    "id": "posture-analysis-landmark-snap",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Turn on landmark and plumb line snap",
    "audience": "app",
    "gatedBy": null,
    "purpose": "See how snap makes a dragged point jump back to its detected spot, and a dragged plumb line jump back to vertical, when you let go close to it.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **Settings**; under **Overlay Settings**, turn on **Landmark snap**, **Plumbline snap**, or both.",
      "Set how close counts as a snap in the **px** box next to each switch."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-landmark-snap/20261018T002445Z.mp4",
    "captions": "help-videos/posture-analysis-landmark-snap/20261018T002445Z.vtt",
    "poster": "help-videos/posture-analysis-landmark-snap/20261018T002445Z.jpg",
    "durationSec": 43,
    "recordedAt": "2026-10-18T00:24:45Z"
  },
  {
    "id": "posture-analysis-move-plumb-line",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Move the plumb line",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Tilt the plumb line by its end handles when the camera or the floor was not level, so Harry reads the photo against a true vertical.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "On a captured photo, drag the round handle at the top or bottom end of the plumb line sideways.",
      "Let go when the line matches true vertical; the edit mode ends on its own a few seconds later."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-move-plumb-line/20261018T001929Z.mp4",
    "captions": "help-videos/posture-analysis-move-plumb-line/20261018T001929Z.vtt",
    "poster": "help-videos/posture-analysis-move-plumb-line/20261018T001929Z.jpg",
    "durationSec": 32,
    "recordedAt": "2026-10-18T00:19:29Z"
  },
  {
    "id": "posture-analysis-open-past",
    "kind": "subsection",
    "section": "posture-analysis",
    "title": "Open a past posture analysis",
    "audience": "app",
    "gatedBy": null,
    "purpose": "See where a client's saved posture analyses live and how to open, move between, edit, and export them.",
    "routes": [
      "/clients/:id",
      "/clients/:id/posture-analysis/:analysisId",
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "On the client's profile, open the **Posture** tab.",
      "Click a date to open that analysis.",
      "To switch visits, pick another date in the analysis menu at the top.",
      "Choose **Edit** to adjust a landmark, then choose **Update**.",
      "Choose **PDF** to download the analysis as a report.",
      "Choose **Back to** to return to the client's profile."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-open-past/20261018T000322Z.mp4",
    "captions": "help-videos/posture-analysis-open-past/20261018T000322Z.vtt",
    "poster": "help-videos/posture-analysis-open-past/20261018T000322Z.jpg",
    "durationSec": 90,
    "recordedAt": "2026-10-18T00:03:22Z"
  },
  {
    "id": "posture-analysis-orientation-strategy",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Choose an orientation method",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Switch the method Harry uses to read the photos for the Posture result.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Experimental Features on, open the **Posture** panel beside the photos.",
      "Under **Orientation**, open the list and choose a method."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-orientation-strategy/20261018T003313Z.mp4",
    "captions": "help-videos/posture-analysis-orientation-strategy/20261018T003313Z.vtt",
    "poster": "help-videos/posture-analysis-orientation-strategy/20261018T003313Z.jpg",
    "durationSec": 28,
    "recordedAt": "2026-10-18T00:33:13Z"
  },
  {
    "id": "posture-analysis-paste-and-assign-photos",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Paste or upload photos and assign views",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Paste a copied photo straight into Posture Analysis, or upload one, and tell Harry which view it is.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "Copy a photo, then press Ctrl+V (Cmd+V on a Mac) on the Posture Analysis screen, or choose **Upload**.",
      "Under **Assign Uploaded Images**, open **Assign View** and choose the view for each photo."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-paste-and-assign-photos/20261018T004348Z.mp4",
    "captions": "help-videos/posture-analysis-paste-and-assign-photos/20261018T004348Z.vtt",
    "poster": "help-videos/posture-analysis-paste-and-assign-photos/20261018T004348Z.jpg",
    "durationSec": 29,
    "recordedAt": "2026-10-18T00:43:48Z"
  },
  {
    "id": "posture-analysis-posterior-view",
    "kind": "subsection",
    "section": "posture-analysis",
    "title": "Add and read the back view",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Add a back photo to a posture analysis and read its measurements next to the front and side views.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Experimental Features on, start a new assessment in **Posture Analysis**.",
      "Choose **Upload** and pick the back photo with the other views; a file name with \"back\" in it goes straight to **Posterior**.",
      "Choose the **Posterior** tab to see the back view with its landmarks.",
      "Open **View Report** to read the back measurements."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-posterior-view/20261018T014042Z.mp4",
    "captions": "help-videos/posture-analysis-posterior-view/20261018T014042Z.vtt",
    "poster": "help-videos/posture-analysis-posterior-view/20261018T014042Z.jpg",
    "durationSec": 101,
    "recordedAt": "2026-10-18T01:40:42Z"
  },
  {
    "id": "posture-analysis-practitioner-observations",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Add your visual observations",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Add what you see on the client, which the photos may not show clearly, so Harry weighs it into the Posture result.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "In the **Posture** panel beside the photos, find \"Visual findings observed by practitioner (optional)\".",
      "Turn on what you see: **Pooch belly**, **Flat/absent glutes**, **Rib flare** or **Flat cervical curve**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-practitioner-observations/20261017T235157Z.mp4",
    "captions": "help-videos/posture-analysis-practitioner-observations/20261017T235157Z.vtt",
    "poster": "help-videos/posture-analysis-practitioner-observations/20261017T235157Z.jpg",
    "durationSec": 26,
    "recordedAt": "2026-10-17T23:51:57Z"
  },
  {
    "id": "posture-analysis-read-result",
    "kind": "subsection",
    "section": "posture-analysis",
    "title": "Read the posture result",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Read a posture result at a basic level: the pattern, the confidence, and the measurements per view.",
    "routes": [
      "/clients/:id/posture-analysis/:analysisId",
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "Open the client's saved posture analysis.",
      "Read the pattern and its confidence bars on the **Posture Classification** card.",
      "Under **Visual Posture Analysis**, pick a view tab: **Anterior**, **Left** or **Right**.",
      "Check the **Metric** and **Analysis** table, starting with the colored values."
    ],
    "flowText": null,
    "keyConcept": "Harry reads the side photos to place a client's standing posture into one of three patterns. Swayback and Anterior Pelvic Tilt describe two different ways the pelvis and trunk stack over the feet, and Stacked means neither of those two patterns shows clearly. The front photo adds a side-to-side read, which appears as a Left or Right chip when one side stands out. A pattern describes how the body is organized at the moment the photos were taken; it can look different at the next analysis.",
    "seeAlso": [],
    "video": "help-videos/posture-analysis-read-result/20261017T235542Z.mp4",
    "captions": "help-videos/posture-analysis-read-result/20261017T235542Z.vtt",
    "poster": "help-videos/posture-analysis-read-result/20261017T235542Z.jpg",
    "durationSec": 87,
    "recordedAt": "2026-10-17T23:55:42Z"
  },
  {
    "id": "posture-analysis-reanalyze",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Re-analyze a saved posture analysis",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Recalculate a saved posture analysis with Harry's current logic, without taking the photos again.",
    "routes": [
      "/clients/:id/posture-analysis/:analysisId"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Experimental Features on, open a saved posture analysis.",
      "Choose **Re-analyze** and wait for **Re-analysis Complete**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-reanalyze/20261018T013140Z.mp4",
    "captions": "help-videos/posture-analysis-reanalyze/20261018T013140Z.vtt",
    "poster": "help-videos/posture-analysis-reanalyze/20261018T013140Z.jpg",
    "durationSec": 18,
    "recordedAt": "2026-10-18T01:31:40Z"
  },
  {
    "id": "posture-analysis-set-floor-manually",
    "kind": "feature",
    "section": "posture-analysis",
    "title": "Set the floor manually",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Set or clear a manual floor correction from the Capture Settings sheet, and read what its Source and Confidence lines mean.",
    "routes": [
      "/posture-analysis"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **Settings** below the photo and scroll to **Plumb Line Correction**.",
      "Choose **Set Floor Manually**, close the sheet, then drag a plumb line handle sideways.",
      "To go back to a plain vertical line, choose **Reset to Auto**."
    ],
    "flowText": null,
    "keyConcept": "Source names where the plumb line's tilt on this photo comes from: \"manual\" when you set it yourself, \"none\" when Harry draws a plain vertical line. Confidence is how sure Harry is of that tilt; your own setting always counts as fully sure, and \"n/a\" means there is nothing to report yet.",
    "seeAlso": [],
    "video": "help-videos/posture-analysis-set-floor-manually/20261018T003003Z.mp4",
    "captions": "help-videos/posture-analysis-set-floor-manually/20261018T003003Z.vtt",
    "poster": "help-videos/posture-analysis-set-floor-manually/20261018T003003Z.jpg",
    "durationSec": 41,
    "recordedAt": "2026-10-18T00:30:03Z"
  },
  {
    "id": "posture-analysis-start-new",
    "kind": "subsection",
    "section": "posture-analysis",
    "title": "Start a posture analysis for a client",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Start a new posture analysis for a client, capture or upload the views, and save it to the client's record.",
    "routes": [
      "/clients/:id",
      "/posture-analysis",
      "/clients/:id/posture-analysis/:analysisId"
    ],
    "alsoShownIn": [],
    "steps": [
      "On the client's profile, choose **Posture**.",
      "If a saved analysis shows, choose **New Assessment** in the assessment menu.",
      "Place the camera at navel height, at least 2 m (6 ft) away.",
      "Choose **Start Camera**, then **Capture** for each view, then **Finish capture**.",
      "Or choose **Upload** and add photos named front, left and right.",
      "Check the landmarks, then choose **Save**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/posture-analysis-start-new/20261018T005030Z.mp4",
    "captions": "help-videos/posture-analysis-start-new/20261018T005030Z.vtt",
    "poster": "help-videos/posture-analysis-start-new/20261018T005030Z.jpg",
    "durationSec": 90,
    "recordedAt": "2026-10-18T00:50:30Z"
  },
  {
    "id": "posture-analysis-taking-photos",
    "kind": "subsection",
    "section": "posture-analysis",
    "title": "Taking and uploading posture photos",
    "audience": "public",
    "gatedBy": null,
    "purpose": "Set up the camera and take or upload posture photos that Harry can read.",
    "routes": [
      "/posture-analysis",
      "/self-assessment"
    ],
    "alsoShownIn": [],
    "steps": [
      "Prop the phone upright, with the lens level with your navel.",
      "Step back at least 2 m (6 ft) so your whole body is in frame.",
      "Wear fitted clothes, keep your hips uncovered, and use even, bright light.",
      "For the front photo, face the camera, feet about shoulder width apart.",
      "For the right side photo, turn to your left so your right shoulder faces the camera.",
      "To upload instead, add each photo to the view asked for, head and feet showing."
    ],
    "flowText": null,
    "keyConcept": "Harry measures lines and angles from your photos, so where the camera sits changes what it sees. With the lens at navel height and kept level, the picture is bent the same amount above and below the lens, and the lens looks straight at the hips, the area that matters most for the result. Distance does the same job: the further back the camera, the less the lens stretches your proportions.",
    "seeAlso": [],
    "video": null,
    "captions": null,
    "poster": null,
    "durationSec": null,
    "recordedAt": null
  },
  {
    "id": "sop-create-assessment",
    "kind": "subsection",
    "section": "sop",
    "title": "Create a new SoP assessment",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Start a new Spectrum of Patterns assessment for a client, choose passive or active mode, enter values, and save.",
    "routes": [
      "/clients",
      "/clients/:id/assessment/new",
      "/sop-assessment"
    ],
    "alsoShownIn": [],
    "steps": [
      "On **Clients**, open the actions menu at the end of the client's row.",
      "Choose **Start Assessment**.",
      "Choose **P** for passive or **A** for active before you type any values.",
      "Type the left and right values on each test card.",
      "Choose **Save**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/sop-create-assessment/20261015T041153Z.mp4",
    "captions": "help-videos/sop-create-assessment/20261015T041153Z.vtt",
    "poster": "help-videos/sop-create-assessment/20261015T041153Z.jpg",
    "durationSec": 92,
    "recordedAt": "2026-10-15T04:11:53Z"
  },
  {
    "id": "sop-goniometer",
    "kind": "subsection",
    "section": "sop",
    "title": "Measure an angle with the goniometer",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Open VisioMeter 3.0 from an SoP assessment, measure an angle on a photo, video, camera frame or shared screen, and apply it to the Left or Right field.",
    "routes": [
      "/clients/:id/assessment/new",
      "/clients/:id/assessment/:assessmentId"
    ],
    "alsoShownIn": [],
    "steps": [
      "On a test card, choose **Open Visual Goniometer**, or choose **VGon** in the toolbar.",
      "Choose **Upload image or video**, **Share screen / call**, or start the camera.",
      "Drag the center handle onto the joint, then line up each arm.",
      "Choose **Apply** to put the angle into the Left field.",
      "Switch to **R**, line up the other side, and choose **Apply** again.",
      "Close **VisioMeter 3.0** with the X button."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/sop-goniometer/20261015T005555Z.mp4",
    "captions": "help-videos/sop-goniometer/20261015T005555Z.vtt",
    "poster": "help-videos/sop-goniometer/20261015T005555Z.jpg",
    "durationSec": 109,
    "recordedAt": "2026-10-15T00:55:55Z"
  },
  {
    "id": "sop-open-existing",
    "kind": "subsection",
    "section": "sop",
    "title": "Open an existing SoP assessment",
    "audience": "app",
    "gatedBy": null,
    "purpose": "See the two ways to find and open a saved Spectrum of Patterns assessment: from the SOP Assessment page, and from the client profile.",
    "routes": [
      "/sop-assessment",
      "/clients/:id",
      "/clients/:id/assessment/:assessmentId",
      "/clients/:id/assessment/:assessmentId/edit"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **SOP Assessment** in the side menu.",
      "If no client is selected, choose **Select Existing Client** and pick your client.",
      "To open an older one, pick a date under **Previous Assessments** in the selector.",
      "Or, from **Clients**, open **Client 360** and choose the **Assessments** tab.",
      "Click a row to open that assessment."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/sop-open-existing/20261015T181323Z.mp4",
    "captions": "help-videos/sop-open-existing/20261015T181323Z.vtt",
    "poster": "help-videos/sop-open-existing/20261015T181323Z.jpg",
    "durationSec": 88,
    "recordedAt": "2026-10-15T18:13:23Z"
  },
  {
    "id": "sop-read-results",
    "kind": "subsection",
    "section": "sop",
    "title": "Read your SoP results",
    "audience": "app",
    "gatedBy": null,
    "purpose": "See where the Spectrum of Patterns results appear: the colors on each test card, the Body Map, and the SoP Table.",
    "routes": [
      "/clients/:id/assessment/:assessmentId"
    ],
    "alsoShownIn": [],
    "steps": [
      "Open the client's saved SoP assessment.",
      "Check each filled test card's colored border and the bar under its fields.",
      "Hover a test name to see its explanation and **Color legend**.",
      "Choose **Body Map** in the toolbar to see the overall pattern.",
      "Choose the **SoP Table** tab to see the result as a table.",
      "Close the view to go back to the sheet."
    ],
    "flowText": null,
    "keyConcept": "Harry reads lateralization as a pattern, not a problem. The Right Lateralized Pattern is the expected baseline human orientation, because of the body's built-in asymmetry, and a Left Lateralized Pattern is usually understood as an adaptation built on top of it. When results disagree, follow the Rule of the Worst Measurement: trust the most limited test, because it shows the true underlying restriction, and a global pattern such as anterior pelvic tilt or swayback can hide the lateralization.",
    "seeAlso": [],
    "video": "help-videos/sop-read-results/20261015T010647Z.mp4",
    "captions": "help-videos/sop-read-results/20261015T010647Z.vtt",
    "poster": "help-videos/sop-read-results/20261015T010647Z.jpg",
    "durationSec": 87,
    "recordedAt": "2026-10-15T01:06:47Z"
  },
  {
    "id": "sop-sheet-image-import",
    "kind": "feature",
    "section": "sop",
    "title": "Fill an SoP assessment from a sheet image",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Fill a Spectrum of Patterns assessment from a photo, screenshot or PDF of your filled-in sheet instead of typing every value.",
    "routes": [
      "/clients/:id/assessment/new",
      "/sop-assessment"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Experimental Features on, open a new SoP assessment for the client.",
      "Choose **Sheet (AI)** and pick the image or PDF of your sheet; you can also paste a screenshot with Ctrl+V.",
      "Check the values Harry filled in on the test cards."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/sop-sheet-image-import/20261018T012933Z.mp4",
    "captions": "help-videos/sop-sheet-image-import/20261018T012933Z.vtt",
    "poster": "help-videos/sop-sheet-image-import/20261018T012933Z.jpg",
    "durationSec": 42,
    "recordedAt": "2026-10-18T01:29:33Z"
  },
  {
    "id": "remote-assessment-video-call",
    "kind": "subsection",
    "section": "remote-assessment",
    "title": "Assess a client over a video call",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Share a video call into Harry and capture posture views and active SoP measurements from it, without the client using Harry.",
    "routes": [
      "/remote-assessment"
    ],
    "alsoShownIn": [
      "/clients/:id"
    ],
    "steps": [
      "Select the client, then choose **Remote Assessment** in the side menu.",
      "Choose **Share call window** and pick your video call window.",
      "On the **Posture Analysis** tab, pick a view, then choose **Capture pose**.",
      "Choose **Review & save**, then save the analysis in the new tab.",
      "On **SOP Assessment**, pick a test, then **Freeze frame**, line up the arms, and **Apply**.",
      "Choose **Save active assessment**, then **Stop sharing** when the call ends."
    ],
    "flowText": null,
    "keyConcept": "Remote measurements come from the client's own camera, so their quality depends on camera height, distance and a still pose. Records captured this way carry a \"Remote\" mark so you can tell them apart from in-clinic measurements.",
    "seeAlso": [],
    "video": "help-videos/remote-assessment-video-call/20261018T053422Z.mp4",
    "captions": "help-videos/remote-assessment-video-call/20261018T053422Z.vtt",
    "poster": "help-videos/remote-assessment-video-call/20261018T053422Z.jpg",
    "durationSec": 138,
    "recordedAt": "2026-10-18T05:34:22Z"
  },
  {
    "id": "drills-build-a-drill-plan",
    "kind": "subsection",
    "section": "drills",
    "title": "Build a drill plan for a client",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Create a drill plan from a template, let Harry fill it from the client's assessments, adjust it, and save it to the client.",
    "routes": [
      "/drills",
      "/drill-planner"
    ],
    "alsoShownIn": [],
    "steps": [
      "In **Settings**, turn on **Enable Experimental Features**.",
      "Choose **Select Client** in the header and pick your client.",
      "Open **Drill Library** and choose **Suggest Drills**.",
      "Under **Choose a Template**, pick a template, such as **Small Drill Plan**.",
      "Enter a **Plan name**, swap drills if needed, and add **Sets** and **Reps**.",
      "Choose **Save & Assign to Client**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/drills-build-a-drill-plan/20261015T231307Z.mp4",
    "captions": "help-videos/drills-build-a-drill-plan/20261015T231307Z.vtt",
    "poster": "help-videos/drills-build-a-drill-plan/20261015T231307Z.jpg",
    "durationSec": 90,
    "recordedAt": "2026-10-15T23:13:07Z"
  },
  {
    "id": "drills-find-and-filter-drills",
    "kind": "subsection",
    "section": "drills",
    "title": "Find and filter drills",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Find the right drill fast with search, filters, tags and favorites, and preview its video.",
    "routes": [
      "/drills"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **Drill Library** in the side menu.",
      "Type a drill name in **Search drills... (Press '/' to focus)**.",
      "Narrow the list with filters, such as **All Phases** and **Posture**.",
      "Click a tag on a drill card to filter by that tag.",
      "Click a drill card to play its video.",
      "Choose the heart to save a favorite, then **Favorites** to show only those."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/drills-find-and-filter-drills/20261015T034101Z.mp4",
    "captions": "help-videos/drills-find-and-filter-drills/20261015T034101Z.vtt",
    "poster": "help-videos/drills-find-and-filter-drills/20261015T034101Z.jpg",
    "durationSec": 94,
    "recordedAt": "2026-10-15T03:41:01Z"
  },
  {
    "id": "drills-reuse-a-saved-drill-plan",
    "kind": "subsection",
    "section": "drills",
    "title": "Find and reuse a saved drill plan",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Find a saved drill plan by name or tag and link it to a client without building it again.",
    "routes": [
      "/drill-plan-library"
    ],
    "alsoShownIn": [],
    "steps": [
      "Select the client in the header first.",
      "Open the **Drill Plan Library** page.",
      "Type a plan name or tag in **Search by name or tag…**.",
      "On the plan card, choose **Link to Client**.",
      "Add a note in **Notes (optional)** if you want one.",
      "Choose **Assign to Client**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/drills-reuse-a-saved-drill-plan/20261018T013815Z.mp4",
    "captions": "help-videos/drills-reuse-a-saved-drill-plan/20261018T013815Z.vtt",
    "poster": "help-videos/drills-reuse-a-saved-drill-plan/20261018T013815Z.jpg",
    "durationSec": 65,
    "recordedAt": "2026-10-18T01:38:15Z"
  },
  {
    "id": "settings-agent-harry",
    "kind": "subsection",
    "section": "ask-harry",
    "title": "Ask Agent hArry",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Start a chat with Agent hArry and ask it about your clients, drills or training programs.",
    "routes": [
      "/agent"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Experimental Features on, choose **Agent hArry** in the side menu.",
      "Choose **New Chat**.",
      "Type your question in the message box and send it.",
      "Read the answer; past chats stay listed under **Conversations**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/settings-agent-harry/20261018T014407Z.mp4",
    "captions": "help-videos/settings-agent-harry/20261018T014407Z.vtt",
    "poster": "help-videos/settings-agent-harry/20261018T014407Z.jpg",
    "durationSec": 52,
    "recordedAt": "2026-10-18T01:44:07Z"
  },
  {
    "id": "settings-coach-chat",
    "kind": "feature",
    "section": "ask-harry",
    "title": "Open the Harry chat from the header",
    "audience": "app",
    "gatedBy": "experimentalFeatures",
    "purpose": "Ask Harry a question from the header on any screen and continue the conversation in Harry Agent.",
    "routes": [
      "/dashboard",
      "/clients"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Experimental Features on, choose the Harry avatar in the header (**Ask Harry: open chat**).",
      "Type your question in **Message Harry…** and choose **Send**.",
      "The chat closes and **Harry Agent** opens a new conversation with your question as its first message."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/settings-coach-chat/20261018T013008Z.mp4",
    "captions": "help-videos/settings-coach-chat/20261018T013008Z.vtt",
    "poster": "help-videos/settings-coach-chat/20261018T013008Z.jpg",
    "durationSec": 26,
    "recordedAt": "2026-10-18T01:30:08Z"
  },
  {
    "id": "progression-model-read-the-three-phases",
    "kind": "subsection",
    "section": "progression-model",
    "title": "Read the three phases",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Use the Progression Model page to see what each of the three phases works on, when a client stays, and how a client moves on.",
    "routes": [
      "/progression-model"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **Progression Model** in the side menu.",
      "Read the journey strip from **Dysfunction** to **Optimal output**.",
      "With **Phase 1 Restore expansion** selected, read **Pattern focus** and **Focus**.",
      "Check **Assessment gates**, **Sample drills** and the **Stay here if** banner.",
      "Choose the **Phase 2** and **Phase 3** tabs to read those phases.",
      "Choose **Browse drills** to open the Drill Library."
    ],
    "flowText": null,
    "keyConcept": "Harry uses a three-phase progression model. Phase 1 restores expansion on both sides: it clears the global pattern (anterior orientation or swayback) and rebuilds the stack. Phase 2 trains the non-lateralized side to build occupancy and control asymmetry. Phase 3 integrates those gains on the originally lateralized side under load. A client moves on only after passing that phase's re-test (the Walking Test after Phase 1, the Occupancy Test after Phase 2) and its assessment gates, whose values come from the evaluation rules. The loop is always the same: assess, intervene, re-assess. (Sources: `src/lib/progression-model/content.ts`, `src/lib/progression-model/phase-goals.ts`, `RuleDocConorHarris.md`, course Week 7 and Week 8 decks.)",
    "seeAlso": [],
    "video": "help-videos/progression-model-read-the-three-phases/20261015T035227Z.mp4",
    "captions": "help-videos/progression-model-read-the-three-phases/20261015T035227Z.vtt",
    "poster": "help-videos/progression-model-read-the-three-phases/20261015T035227Z.jpg",
    "durationSec": 88,
    "recordedAt": "2026-10-15T03:52:27Z"
  },
  {
    "id": "progression-model-when-progress-stalls",
    "kind": "subsection",
    "section": "progression-model",
    "title": "When progress stalls",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Use the troubleshooting checks and key terms on the Progression Model page when a client stops improving.",
    "routes": [
      "/progression-model"
    ],
    "alsoShownIn": [],
    "steps": [
      "Open the **Progression Model** page.",
      "In the **When progress stalls** panel, choose **Expand**.",
      "Work through **1. Check execution** first.",
      "Then work through **2. Investigate lifestyle** and **3. Cranial & cervical influences**.",
      "Expand **Key terms** to look up words used across the model."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/progression-model-when-progress-stalls/20261015T014154Z.mp4",
    "captions": "help-videos/progression-model-when-progress-stalls/20261015T014154Z.vtt",
    "poster": "help-videos/progression-model-when-progress-stalls/20261015T014154Z.jpg",
    "durationSec": 76,
    "recordedAt": "2026-10-15T01:41:54Z"
  },
  {
    "id": "settings-app-switches",
    "kind": "subsection",
    "section": "settings",
    "title": "Turn app options on or off",
    "audience": "app",
    "gatedBy": null,
    "purpose": "See the three switches on the Settings page that change how parts of Harry behave: posture tips, the SoP assessment version, and experimental previews.",
    "routes": [
      "/settings"
    ],
    "alsoShownIn": [],
    "steps": [
      "Open **Settings**.",
      "In **SoP Assessment Mode**, leave **Use Legacy SoP Assessment (pre-March 2026)** off.",
      "In the **Experimental Features** card, turn **Enable Experimental Features** on or off."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/settings-app-switches/20261014T234307Z.mp4",
    "captions": "help-videos/settings-app-switches/20261014T234307Z.vtt",
    "poster": "help-videos/settings-app-switches/20261014T234307Z.jpg",
    "durationSec": 57,
    "recordedAt": "2026-10-14T23:43:07Z"
  },
  {
    "id": "settings-appearance-and-units",
    "kind": "subsection",
    "section": "settings",
    "title": "Change theme and measurement units",
    "audience": "app",
    "gatedBy": null,
    "purpose": "Change Harry's look (theme mode and font) and switch between metric and imperial units.",
    "routes": [
      "/settings",
      "/clients"
    ],
    "alsoShownIn": [],
    "steps": [
      "Choose **Settings** in the side menu.",
      "In **Appearance & Theme**, pick **Light**, **Dark** or **System**.",
      "Under **Typography**, choose a font.",
      "Choose **Reset to Defaults** to get the original look back.",
      "Under **Measurement Units**, choose **Metric System** or **Imperial System**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/settings-appearance-and-units/20261014T233658Z.mp4",
    "captions": "help-videos/settings-appearance-and-units/20261014T233658Z.vtt",
    "poster": "help-videos/settings-appearance-and-units/20261014T233658Z.jpg",
    "durationSec": 79,
    "recordedAt": "2026-10-14T23:36:58Z"
  },
  {
    "id": "admin-invite-user",
    "kind": "subsection",
    "section": "admin",
    "title": "Invite a new user",
    "audience": "admin",
    "gatedBy": null,
    "purpose": "Invite a new user by email, give them a role, and send or copy their sign-in link.",
    "routes": [
      "/admin/users"
    ],
    "alsoShownIn": [],
    "steps": [
      "Turn on Admin Mode, then choose **User Management** under **Admin** in the side menu.",
      "Choose **Invite user**.",
      "Type the person's email, then pick their role in the role list.",
      "Leave **Send sign-in email now** ticked, then choose **Invite**.",
      "To send the link yourself, use the link button on the new user's row."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/admin-invite-user/20261015T205857Z.mp4",
    "captions": "help-videos/admin-invite-user/20261015T205857Z.vtt",
    "poster": "help-videos/admin-invite-user/20261015T205857Z.jpg",
    "durationSec": 86,
    "recordedAt": "2026-10-15T20:58:57Z"
  },
  {
    "id": "admin-manage-user-roles",
    "kind": "subsection",
    "section": "admin",
    "title": "Find a user and change their roles",
    "audience": "admin",
    "gatedBy": null,
    "purpose": "Find a user, add or remove a role, change their display name, and delete or restore their access.",
    "routes": [
      "/admin/users"
    ],
    "alsoShownIn": [],
    "steps": [
      "Open **User Management** and type part of the email in **Search email key...**.",
      "Choose the add role button on the row, pick the role, then choose **Assign**.",
      "To remove a role, choose the small x on its chip, then **Remove**.",
      "Choose the edit button, change **Display name**, then choose **Save display name**.",
      "To remove access, choose the delete button on the row, then **Delete**.",
      "To bring a user back, set the lifecycle list to **Deleted**, then choose **Restore**."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": null,
    "captions": null,
    "poster": null,
    "durationSec": null,
    "recordedAt": null
  },
  {
    "id": "admin-turn-on-admin-mode",
    "kind": "subsection",
    "section": "admin",
    "title": "Turn on Admin Mode",
    "audience": "admin",
    "gatedBy": null,
    "purpose": "Turn on Admin Mode so the Admin pages, User Management and Statistics, appear in the side menu.",
    "routes": [
      "/settings",
      "/admin/users",
      "/admin/statistics"
    ],
    "alsoShownIn": [],
    "steps": [
      "Open **Settings** and scroll to the **Admin Mode** card.",
      "Turn on **Enable Admin Mode**.",
      "Find **User Management** and **Statistics** under **Admin** in the side menu.",
      "Turn **Enable Admin Mode** off when you are done."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/admin-turn-on-admin-mode/20261015T011128Z.mp4",
    "captions": "help-videos/admin-turn-on-admin-mode/20261015T011128Z.vtt",
    "poster": "help-videos/admin-turn-on-admin-mode/20261015T011128Z.jpg",
    "durationSec": 66,
    "recordedAt": "2026-10-15T01:11:28Z"
  },
  {
    "id": "admin-view-statistics",
    "kind": "subsection",
    "section": "admin",
    "title": "View platform statistics and export active users",
    "audience": "admin",
    "gatedBy": null,
    "purpose": "Read the platform overview on the Statistics page and download a list of active users as a CSV file.",
    "routes": [
      "/admin/statistics"
    ],
    "alsoShownIn": [],
    "steps": [
      "With Admin Mode on, choose **Statistics** under **Admin** in the side menu.",
      "Read the **Platform Overview** cards at the top.",
      "Under **Active Users & Activity Export**, pick a time window, such as **Last 30 Days**.",
      "Next to **Roles:**, choose which roles to include.",
      "Choose **Export CSV** to download the list."
    ],
    "flowText": null,
    "keyConcept": null,
    "seeAlso": [],
    "video": "help-videos/admin-view-statistics/20261015T210511Z.mp4",
    "captions": "help-videos/admin-view-statistics/20261015T210511Z.vtt",
    "poster": "help-videos/admin-view-statistics/20261015T210511Z.jpg",
    "durationSec": 76,
    "recordedAt": "2026-10-15T21:05:11Z"
  }
];
